import React from 'react';
import { Row } from 'components/Containers/Row/Row';
import { Button } from 'components/form/Button/Button';
import { useHistory } from 'react-router-dom';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { SESAME_PLUS_CARDS_OFFERS } from 'types/morph.pagePosition.constants';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { useEventHandler } from 'hook/event.hook';
import classnames from 'classnames';

const GoToCCMarketplaceButton = ({
  onClickHandler,
  destination = '/offers/creditcard',
  moduleName = SESAME_PLUS_CARDS_OFFERS,
  showDesktop,
  fullWidth,
  className,
}) => {
  const history = useHistory();
  const eventHandler = useEventHandler();

  const goToMarketplace = () => {
    history.push(destination);
    eventHandler(CLICK, {
      'Click Type': 'See all Cards',
      'Module name': moduleName,
    });
  };

  const buttonClass = classnames({
    'd-hide': !showDesktop,
    'm-hide': showDesktop,
  });

  const rowClass = classnames('m-padLR0 noPadMobile', className, {
    width100: fullWidth,
  });
  return (
    <Row className={rowClass}>
      <FlexContainer className={buttonClass}>
        <Button
          mrphType="standardBlue"
          className="Body1"
          rounded="100px"
          fullWidth={fullWidth}
          onClick={onClickHandler || goToMarketplace}
        >
          See More Cards
        </Button>
      </FlexContainer>
    </Row>
  );
};

export default GoToCCMarketplaceButton;
